import getRuntimeEnv from './env';

const createAuthPath = (): string =>
  getRuntimeEnv().NODE_ENV === 'development' ? '//localhost:8080/auth' : '/auth';

export default createAuthPath;
